export const parseJsonIfString = (value: unknown) =>
  typeof value === 'string' ? JSON.parse(value) : value;

export const processFormValue = (value: unknown, key: string): unknown => {
  if (typeof value !== 'string') {
    return value;
  }
  if (value.trim() === 'null' || value.trim() === 'undefined') {
    return null;
  }
  if (value === 'true' || value === 'false') {
    return value === 'true';
  }
  if (!isNaN(Number(value)) && value.trim() !== '') {
    return Number(value);
  }
  return value.trim().replace(/"/g, '');
};

export const processRepositoryList = (
  repositories: unknown,
): unknown[] | undefined => {
  if (!repositories) {
    return undefined;
  }

  if (!Array.isArray(repositories)) {
    return [parseJsonIfString(repositories)];
  }

  return repositories.map(parseJsonIfString);
};

export const processDomainConfigList = (domains: unknown): unknown[] => {
  if (!domains) {
    return [];
  }

  if (!Array.isArray(domains)) {
    return [parseJsonIfString(domains)];
  }

  return domains.map(parseJsonIfString);
};
